import { PRODUCT_OVERVIEW_PATH } from "@/lib/hub/public-nav-links";

/** Marketing pages that render with the landing chrome (LandingNav2, dark body) instead of the terminal TopNav. */
const LANDING_PATHS = new Set([
  "/",
  "/about",
  "/methodology",
  "/pricing",
  "/map",
  "/landing",
  "/landing2",
  PRODUCT_OVERVIEW_PATH,
  "/offer",
]);

export function isLandingPath(pathname: string | null | undefined): boolean {
  return pathname != null && LANDING_PATHS.has(pathname);
}
